var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("WorkflowApplyDetail", { ref: "WorkflowApplyDetail" }),
      _vm._v(" "),
      _c("table", { staticStyle: { width: "90%" } }, [
        _c("tr", [
          _c("td", [
            _c("div", { staticStyle: { float: "left" } }, [
              _c("h1", [_vm._v(_vm._s(_vm.translateWords.CRKRecord))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c(
            "td",
            [
              _c("el-input", {
                attrs: { placeholder: _vm.translateWords.inputName },
                model: {
                  value: _vm.spmc,
                  callback: function($$v) {
                    _vm.spmc = $$v
                  },
                  expression: "spmc"
                }
              })
            ],
            1
          ),
          _c(
            "td",
            [
              _c("el-input", {
                attrs: { placeholder: _vm.translateWords.inputspbm },
                model: {
                  value: _vm.spbm,
                  callback: function($$v) {
                    _vm.spbm = $$v
                  },
                  expression: "spbm"
                }
              })
            ],
            1
          ),
          _c(
            "td",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.query } },
                [_vm._v(_vm._s(_vm.translateWords.query))]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("tr", [
          _c(
            "td",
            { staticStyle: { padding: "10px" } },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.translateWords.operator },
                model: {
                  value: _vm.czr,
                  callback: function($$v) {
                    _vm.czr = $$v
                  },
                  expression: "czr"
                }
              })
            ],
            1
          ),
          _c(
            "td",
            { staticStyle: { padding: "10px" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "date",
                  format: "yyyy-MM-dd",
                  placeholder: _vm.translateWords.startTime
                },
                model: {
                  value: _vm.qssj,
                  callback: function($$v) {
                    _vm.qssj = $$v
                  },
                  expression: "qssj"
                }
              })
            ],
            1
          ),
          _c(
            "td",
            { staticStyle: { padding: "10px" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "date",
                  format: "yyyy-MM-dd",
                  placeholder: _vm.translateWords.endTime
                },
                model: {
                  value: _vm.jssj,
                  callback: function($$v) {
                    _vm.jssj = $$v
                  },
                  expression: "jssj"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        { staticStyle: { width: "100%" }, attrs: { data: _vm.tableData } },
        [
          _c("el-table-column", {
            attrs: { prop: "Id", label: _vm.translateWords.code, width: "100" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "ProductName",
              label: _vm.translateWords.productName,
              width: "200"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "200",
              prop: "ProductCode",
              label: _vm.translateWords.ProductCode
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "200",
              prop: "OpType",
              label: _vm.translateWords.OpType
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "100",
              prop: "SumCount",
              label: _vm.translateWords.SumCount
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "200",
              prop: "CreateName",
              label: _vm.translateWords.CreateName
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "200",
              prop: "CreateTime",
              formatter: _vm.dateFormat,
              label: _vm.translateWords.CreateTime
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "200", label: _vm.translateWords.ApplyID },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.openworkflow(scope.row.ApplyID)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(scope.row.ApplyID ? scope.row.ApplyID : "")
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          "current-page": 1,
          "page-sizes": [10, 20, 30],
          "page-size": 10,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52e84a0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52e84a0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RKRecord.vue
// module id = null
// module chunks = 